module.exports = __webpack_public_path__ + "img/help1-2-1.cdcd0bd4.png";